customElements.get("recipient-form") || customElements.define("recipient-form", class extends HTMLElement {
  constructor() {
    super();
    this.checkboxInput = this.querySelector(`#Recipient-Checkbox-${this.dataset.sectionId}`);
    this.checkboxInput.disabled = false;
    this.hiddenControlField = this.querySelector(`#Recipient-Control-${this.dataset.sectionId}`);
    this.hiddenControlField.disabled = true;
    this.fields = this.querySelector(".m-recipient-form__fields");
    this.emailInput = this.querySelector(`#Recipient-email-${this.dataset.sectionId}`);
    this.nameInput = this.querySelector(`#Recipient-name-${this.dataset.sectionId}`);
    this.phoneInput = this.querySelector(`#Recipient-phone-${this.dataset.sectionId}`);
    this.messageInput = this.querySelector(`#Recipient-message-${this.dataset.sectionId}`);
    this.addEventListener("change", this.onChange.bind(this));
  }

  onChange() {
    if (this.checkboxInput.checked) {
      this.fields.classList.add("show");
      this.hiddenControlField.disabled = false;
    } else {
      this.fields.classList.remove("show");
      this.hiddenControlField.disabled = true;
      this.clearInputFields();
    }
  }

  clearInputFields() {
    this.emailInput.value = "";
    this.nameInput.value = "";
    this.phoneInput.value = "";
    this.messageInput.value = "";
  }
});
